import React, { useState, useEffect, useCallback } from 'react';

// Services
import { formatterService } from '../../services/formatters.service';
import { purchaseService } from '../../services/purchase.service';

// Redux
import { useDispatch } from 'react-redux';
import { setPayed } from '../../stores/paymentSlice';
import { ReactComponent as PagarmeBrand } from '../../assets/icons/pagarme - selo.svg';

// Components
import InputComponent from '../InputComponent';
import ButtonFullComponent from '../ButtonFullComponent';
import PixPaymentComponent from './PixPaymentComponent';
import SelectComponent from "../../components/SelectComponent";

const PaymentModalComponent = ({ show, handleClose, paymentData, showPaymentStatus }) => {
    const dispatch = useDispatch();
    const [paymentMethod, setPaymentMethod] = useState('');

    const { orderId, total } = paymentData;

    const [formData, setFormData] = useState({
        cardNumber: '',
        cardHolder: '',
        cardDocHolder: '',
        expiryDate: '',
        cvv: '',
        installments: ''
    });

    const [executingPaymentLoading, setExecutingPaymentLoading] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState({ error: false, message: "", paymentId: "" });

    //  Pix
    const [pixPaymentData, setPixPaymentData] = useState({
        pixLoading: false,
        codeCopied: false,
        executeSocket: false,
        qrCode: "",
        paymentId: "",
        orderId: 0,
        executePayment: false
    });

    const memoizedHandleClose = useCallback(() => {
        handleClose();
    }, [handleClose]);

    const memoizedShowPaymentStatus = useCallback(() => {
        showPaymentStatus();
    }, [showPaymentStatus]);

    useEffect(() => {

        if (pixPaymentData.executeSocket && pixPaymentData.paymentId) {

            var wsUrl = `${process.env.REACT_APP_PAYMENT_SOCKET}/payment?group_id=${pixPaymentData.paymentId}`;
            const ws = new WebSocket(wsUrl);

            console.log("Iniciado o socket!");
            console.log(wsUrl);

            ws.onopen = () => {
                console.log('Connected to WebSocket');
                // Send blank message
                ws.send({});
            };

            ws.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    if (data.status === 'paid') {
                        console.log("Encontrou pagamento...");

                        let os_number = data?.hydra_so_number ?? 0;

                        ws.close();
                        memoizedHandleClose();
                        memoizedShowPaymentStatus();

                        // Define store de pagamento realizado!
                        dispatch(setPayed({ payed: true, os_number: os_number }));
                        setPixPaymentData((prev) => ({ ...prev, executeSocket: false, paymentId: '', executePayment: false }));
                    }
                } catch (error) {

                }
            };

            ws.onclose = () => {
                console.log('Disconnected from WebSocket');
            };



            return () => {
                ws.close();
            };
        }

    }, [pixPaymentData.executeSocket, pixPaymentData.paymentId, memoizedHandleClose, memoizedShowPaymentStatus, dispatch]);

    const handlePaymentChange = async (event) => {
        setPaymentMethod(event.target.value);
        setPaymentStatus({ error: false });

        if (event.target.value == "card") {
            setPixPaymentData((prev) => ({ ...prev, executeSocket: false, paymentId: '', executePayment: false }));
        }
        else {
            setPixPaymentData((prev) => ({ ...prev, executePayment: false }));
        }
    };

    const handleInputChange = (event) => {
        const { id, value } = event.target;

        setFormData({ ...formData, [id]: value });
    };

    const executePayOrder = async () => {
        if (paymentMethod === 'card') {
            try {
                setExecutingPaymentLoading(true);

                var paymentCardResponse = await purchaseService.payment(orderId, paymentMethod, formData);
                if (paymentCardResponse) {

                    if (paymentCardResponse.message) {
                        setPaymentStatus({ error: true, message: paymentCardResponse.message });
                        return;
                    }

                    if (paymentCardResponse.status === "paid" && paymentCardResponse.payment_id) {
                        setPaymentStatus({ error: false, message: "", id: paymentCardResponse.payment_id });
                        showPaymentStatus();
                        handleClose();

                        // Define store de pagamento realizado!
                        dispatch(setPayed({ payed: true, os_number: paymentCardResponse.hydra_so_number }));

                        return;
                    }
                    else {
                        let message = "Não foi possível processar o pagamento";
                        if (paymentCardResponse?.message) message = paymentCardResponse.message;
                        setPaymentStatus({ error: true, message: message });
                        return;
                    }
                }

            } catch (error) {
                dispatch(setPayed({ payed: false }));
                let message = "Não foi possível processar o pagamento";
                if (error?.message) message = error.message;
                setPaymentStatus({ error: true, message: message });
            }
            finally {
                setExecutingPaymentLoading(false);
            }
        }
        else if (paymentMethod === 'pix') {

            try {
                setExecutingPaymentLoading(true);

                var paymentPixResponse = await purchaseService.payment(orderId, paymentMethod, formData);
                if (paymentPixResponse) {

                    if (paymentPixResponse.message) {
                        setPaymentStatus({ error: true, message: paymentPixResponse.message });
                        return;
                    }

                    if (paymentPixResponse.status === "pending" && paymentPixResponse.payment_id && paymentPixResponse.pix_qr_code) {

                        const payload = {
                            pixLoading: true,
                            executeSocket: true,
                            qrCode: paymentPixResponse.pix_qr_code,
                            pixCodeToCopy: paymentPixResponse.pix,
                            paymentId: paymentPixResponse.payment_id,
                            orderId: orderId,
                            executePayment: true
                        };

                        setPixPaymentData(payload);

                        return;
                    }
                    else {
                        let message = "Não foi possível processar o pagamento";
                        if (paymentPixResponse?.message) message = paymentPixResponse.message;
                        setPaymentStatus({ error: true, message: message });
                        return;
                    }
                }

            } catch (error) {
                setPaymentStatus({ error: true, message: "Não foi possível processar o pagamento" });
            }
            finally {
                setExecutingPaymentLoading(false);
                setPixPaymentData((prev) => ({ ...prev, pixLoading: false }));
            }
        }
    };

    const handleExpiryDate = (event) => {
        let value = event.target.value;
        // Remove caracteres não numéricos
        value = value.replace(/\D/g, '');

        // Limita o tamanho máximo para 4 caracteres (MM / AA)
        if (value.length > 4) {
            value = value.slice(0, 4);
        }

        // Aplica a máscara MM / AA
        if (value.length > 2) {
            value = value.slice(0, 2) + ' / ' + value.slice(2);
        }
        handleInputChange({ target: { id: 'expiryDate', value: value } });
    };

    const handleCreditCardChange = (event) => {
        let value = event.target.value;
        const { id } = event.target;

        // Remove qualquer caractere não numérico
        value = value.replace(/\D/g, '');

        let maskedValue = '';

        if (value.length <= 16) {

            // Aplica a máscara de cartão de crédito
            for (let i = 0; i < value.length; i++) {
                if (i > 0 && i % 4 === 0) {
                    maskedValue += ' '; // Adiciona um espaço a cada 4 dígitos
                }
                maskedValue += value[i];
            }

            // Atualiza o estado com o valor puro
            setFormData({ ...formData, [id]: maskedValue });
        }
    };

    const handleDocumentChange = (event) => {
        let value = event.target.value;
        const { id } = event.target;

        // Remove qualquer caractere não numérico
        value = value.replace(/\D/g, '');
        if (value.length <= 11) {
            // Máscara para CPF: 000.000.000-00
            value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4');
        } else {
            // Máscara para CNPJ: 00.000.000/0000-00
            value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5');
        }
        // Atualiza o estado com o valor formatado
        setFormData({ ...formData, [id]: value });
    };

    const handleCVVChange = (event) => {
        const { id, value } = event.target;
        // Remove qualquer caractere não numérico
        let newValue = value.replace(/\D/g, '');

        // Limita o valor a 4 dígitos
        newValue = newValue.slice(0, 4);

        setFormData({ ...formData, [id]: newValue });
    };

    const enablePayment = () => {

        if (formData.cardNumber && formData.cardHolder && formData.expiryDate && formData.cvv)
            return true;

        if (paymentMethod === "pix" && pixPaymentData.executePayment == false) return true;

        return false

    };

    const renderWhatsButton = () => {

        const whatsappUrl = process.env.REACT_APP_WHATSAPP_URL;

        return (
            <div className='whats-button'>
                <a href={whatsappUrl || "#"} target="_blank" rel="noopener noreferrer">
                    <img style={{ width: '10rem' }}
                        src={`${process.env.PUBLIC_URL}/assets/whatsapp.png`}
                        alt="WhatsApp"

                    />
                </a>
            </div>
        )
    };

    return (
        <div className={`modal ${show ? 'd-block' : 'd-none'}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header text-center">
                        <h5 className="modal-title text-center" >Pagamento </h5>
                        <button type="button" className="btn-close" onClick={handleClose} disabled={executingPaymentLoading}></button>
                    </div>
                    <div className="modal-body">

                        <div className='payment-container'>

                            <span>Pagando: <span className='payment-value'>{formatterService.toPtCurrency(total)}</span></span>


                            <p>Selecione a forma de pagamento</p>

                            <div className='payment-buttons'>

                                <div
                                    className={`payment-button ${paymentMethod === 'pix' ? 'selected' : ''} ${executingPaymentLoading ? 'disabled' : ''}`}
                                    onClick={async () => handlePaymentChange({ target: { value: 'pix' } })}
                                >
                                    <i className="bi bi-qr-code" style={{ height: '40px', fontSize: '15px' }}></i>
                                    <span>PIX</span>
                                </div>
                                <div
                                    className={`payment-button ${paymentMethod === 'card' ? 'selected' : ''} ${executingPaymentLoading ? 'disabled' : ''}`}
                                    onClick={async () => handlePaymentChange({ target: { value: 'card' } })}
                                >
                                    <i className="bi bi-credit-card" style={{ width: '40px', fontSize: '18px' }}></i>
                                    <span>Cartão de Crédito</span>
                                </div>

                            </div>

                            {paymentMethod === 'pix' && (
                                <PixPaymentComponent pixPaymentData={pixPaymentData} />
                            )}

                            {paymentMethod === 'card' && (
                                <>
                                    <h6>Informe os dados do cartão de crédito</h6>

                                    <div className="container" style={{
                                        padding: '10px',
                                        border: '1px #949494 solid',
                                        borderRadius: '14px'
                                    }}>

                                        <div className='row' >
                                            <div className="col-lg-6 col-sm-12 mb-2">
                                                <InputComponent
                                                    id="cardHolder"
                                                    label="Nome do Titular"
                                                    placeholder="Nome do Titular"
                                                    type="text"
                                                    customClass="card-order-input"
                                                    handleInput={handleInputChange}
                                                    value={formData.cardHolder || ""} />

                                            </div>
                                            <div className="col-lg-6 col-sm-12 mb-2">
                                                <InputComponent
                                                    id="cardDocHolder"
                                                    label="CPF ou CNPJ do Titular"
                                                    placeholder="CPF ou CNPJ"
                                                    type="text"
                                                    customClass="card-order-input"
                                                    handleInput={handleDocumentChange}
                                                    value={formData.cardDocHolder || ""} />
                                            </div>
                                        </div>
                                        <div className='row'>

                                            <div className="col-lg-6 col-sm-12 mb-2">
                                                <InputComponent
                                                    id="cardNumber"
                                                    label="Número do Cartão"
                                                    placeholder="Número do Cartão"
                                                    type="text"
                                                    customClass="card-order-input"
                                                    handleInput={handleCreditCardChange}
                                                    value={formData.cardNumber || ""} />
                                            </div>

                                            <div className="col-lg-4 col-sm-12 mb-2">

                                                <InputComponent
                                                    id="expiryDate"
                                                    label="Data de Validade"
                                                    placeholder='MM / AA'
                                                    type="text"
                                                    customClass="card-order-input"
                                                    value={formData.expiryDate || ""}
                                                    handleInput={handleExpiryDate} />


                                            </div>

                                            <div className="col-lg-2 col-sm-12 mb-2">

                                                <InputComponent
                                                    id="cvv"
                                                    label="CVV"
                                                    placeholder='CVV'
                                                    type="text"
                                                    customClass="card-order-input"
                                                    value={formData.cvv || ""}
                                                    handleInput={handleCVVChange} />

                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="offset-lg-6 col-lg-6 col-sm-12 mb-2">
                                                <SelectComponent
                                                    id="installments"
                                                    label="Quantidade de parcelas"
                                                    placeholder="Selecione a quantidade de parcelas"
                                                    items={[
                                                        {value: 1, text: '1x Sem juros'},
                                                        {value: 2, text: '2x Sem juros'},
                                                        {value: 3, text: '3x Sem juros'}
                                                    ]}
                                                    value={formData.installments}
                                                    handleInput={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>
                        {paymentStatus.error && (
                            <div className="alert alert-danger m-3" role="alert">
                                {paymentStatus.message}
                                <span>. Se precisar entre em contato via whatsapp: {renderWhatsButton()} </span>
                            </div>
                        )}

                    </div>


                    <div className="modal-footer" style={{justifyContent: 'space-between'}}>
                        <div style={{maxWidth: '50%'}}>
                            <PagarmeBrand style={{width: '100%'}} />
                        </div>

                        {pixPaymentData.executePayment ||
                            <ButtonFullComponent text="Pagar Agora" icon_style="bi bi-wallet2" loading={executingPaymentLoading} disabled={!enablePayment()} handleClick={async () => executePayOrder(paymentMethod)} />
                        }

                    </div>


                </div>
            </div>
        </div>
    );
};

export default PaymentModalComponent;
